import { render, staticRenderFns } from "./PemdaTransactionPaymentContent.vue?vue&type=template&id=6f09b6cc&lang=pug"
import script from "./PemdaTransactionPaymentContent.vue?vue&type=script&lang=js"
export * from "./PemdaTransactionPaymentContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports